import { render, staticRenderFns } from "./ClientServiceSpots.vue?vue&type=template&id=754d2f9e"
import script from "./ClientServiceSpots.vue?vue&type=script&lang=js"
export * from "./ClientServiceSpots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports